import React, { useState, useEffect } from 'react';
import './dashboardmenu.css';
import { Link } from 'react-router-dom';

function Dashboardmenup() {
    const [showGerne, setShowGerne] = useState(false);

    const toggleMenu = () => {
        setShowGerne(!showGerne);
    };

    const [userRole, setUserRole] = useState(null);

    const loc = window.location;
    const baseUrl = `${loc.protocol}//${loc.hostname}${loc.hostname === 'localhost' ? ':5000' : ''}`;
    const dynamicrequireAuth = '/requireAuth';
    const requireAuthurl = baseUrl + dynamicrequireAuth;

    useEffect(() => {
        const fetchRoles = async () => {
            await fetch(requireAuthurl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
            })
                .then(response => response.json())
                .then(data => {
                    setUserRole(data)
                });
        };

        fetchRoles();
    }, []);

    if (userRole !== null) {

        return (
            <div className="library-nav">
                <div className="library-nav-header" onClick={toggleMenu}>
                    <h2>Dashboard Menu</h2>
                    <span className="library-nav-toggle">{showGerne ? '\u00d7' : '\u2630'}</span>
                </div>

                <div className={`library-nav-links ${showGerne ? 'open' : ''}`}>
                    <Link to="/onlinebookstats"
                        state={{ data: { categoryview: "arts", catname: "Arts", nxtpage: 1, searchactive: "off" } }}
                        className="library-nav-link"
                    >
                        Online Books
                    </Link>
                    <Link to="/phybookstats"
                        state={{ data: { categoryview: "music", catname: "Music", nxtpage: 1, searchactive: "off" } }}
                        className="library-nav-link"
                    >
                        Physical Books
                    </Link>
                    <Link to="/studentsstatslib" className="library-nav-link">Students Stats</Link>
                    <Link to="/circulationhistory" className="library-nav-link">Borrow History</Link>
                    <Link to="/studentsstatus" className="library-nav-link">Student Status</Link>
                    <Link to="/classreadingresults" className="library-nav-link">Class Reading Results</Link>

                    {userRole.message === "adminh1" && (
                        <>
                            <Link to="/websitestats" className="library-nav-link">Websitestats</Link>
                            <Link to="/classeslist" className="library-nav-link">School Classes</Link>
                            <Link to="/teachingareas" className="library-nav-link">Teaching Areas</Link>
                            <Link to="/subjectlist" className="library-nav-link">School Subjects</Link>
                            <Link to="/classlist" className="library-nav-link">Class List</Link>
                            <Link to="/feestructure" className="library-nav-link">Fees Structure</Link>
                            <Link to="/importattendance" className="library-nav-link">Import Attendance</Link>
                            <Link to="/managehikvisionid" className="library-nav-link">Manage Attendance Id</Link>
                            <Link to="/manageholidays" className="library-nav-link">Manage Holidays</Link>  
                            <Link to="/studentsstatslib" className="library-nav-link">Students Stats</Link>
                            <Link to="/circulationhistory" className="library-nav-link">Borrow History</Link>
                            <Link to="/deviceOnboarding" className="library-nav-link">Devices</Link>
                            <Link to="/generatereportcard" className="library-nav-link">Generate Report</Link>
                            <Link to="/downloadmerits" className="library-nav-link">Download Merits</Link>
                            <Link to="/parental" className="library-nav-link">Parental Control</Link>
                            <Link to="/parental/class-devices" className="library-nav-link">Class Devices</Link>
                            
                            
                            
                        </>
                    )}

                    {userRole.message === "library" && (
                        <>
                            <Link to="/addtest" className="library-nav-link">Quiz</Link>
                            <Link to="/evaluatesummary" className="library-nav-link">Book Summary</Link>
                            <Link className="library-nav-link">Circulation</Link>
                            <Link className="library-nav-link">Lost Books</Link>
                            <Link className="library-nav-link">Reserved Books</Link>
                            <Link to="/readingresults" className="library-nav-link">Edit Reading Results</Link>
                            <Link to="/addteacherlist" className="library-nav-link">Teacher List</Link>
                            <Link to="/register" className="library-nav-link">Register</Link>
                            <Link to="/activityanswer" className="library-nav-link">Activity Answer</Link>
                            <Link to="/reportsubjectslist" className="library-nav-link">Reports Details</Link>
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default Dashboardmenup;